import { createSelector } from '@ngrx/store';
import { getSignupMemberFormFields } from '../getSignupMemberFormFields';

export const getSignupMemberFormFieldsData = createSelector(getSignupMemberFormFields, (singupMemberFormFields) => singupMemberFormFields.data);
